import React from 'react';

/**
 * Adds empty placeholder div elements to array of items to be rendered if less than 9 (the number of jackets or author icons we currently show)
 * @param {array} elementList The list of rendered elements passed in from the model to the view
 * @param {string} className The class name to add to the placeholder element
 * @return {array} The full list of rendered and placeholder elements (if they were necessary)
 */
export function addPlaceholderElements(elementList, className) {
    var renderedItems = elementList.slice();
	try {
        while (renderedItems.length < 9) {
            renderedItems.push(<div key={renderedItems.length} className={className} />)
        }
	} catch (e) {
		return renderedItems;
	}

	return renderedItems;
}



// WEBPACK FOOTER //
// ./src/lib/PlaceholderUtility.jsx